module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#sports",
      toString: function () {
        return this.url;
      }
    }